import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

export const fetchUserPermissions = createAsyncThunk(
  'access/fetchUserPermissions',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/access', null, token);
      return data;
    } catch (err) {
      console.error('get access permission error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
